export default function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/utils/abs-round.js